query pasta($codigo: String!) {
    pasta(codigo: $codigo) {
        agenciaCodigo: agencia2Codigo
        agencia2 {
            regional
        }
    }
}